<script >
import emptyImg from "@/assets/img/empty-page.svg"
export default {
  name: "empty",
  data(){
    return {
      emptyImg
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<template>
  <div class="page">
      <img class="icon" :src="emptyImg" alt="">
     <div class="text">
       哎呀，内容消失了~
     </div>
      <div class="ba
      ck" @click="back">
        返回
      </div>
  </div>
</template>

<style lang="scss" scoped>
.page{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 137px;


    .icon{
      width: 122px;
      height: 88px;
      margin-bottom: 22px;
    }
    .text{
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
    .back{
      color: #666666;
      font-size: 14px;
      font-weight: 600;
      padding: 10px 20px;
      border-radius: 26px;
      margin-top: 12px;
      background: #f5f5f5;
      &:active{
        opacity: .8;
      }
  }
}
</style>